import { useTranslation } from 'react-i18next';
import type { Failure } from './lab-package-format';
import styles from './LabPackages.module.css';

/** An API failure in a lab package / booking form, with the requestId. */
export function LabFailureBox({ failure }: { failure: Failure }) {
  const { t } = useTranslation();
  return (
    <div className={styles.error} role="alert">
      {failure.title}
      {failure.unknownTests && failure.unknownTests.length > 0 && (
        <span>Not in the catalogue: {failure.unknownTests.join(', ')}</span>
      )}
      {failure.detail && <span>{failure.detail}</span>}
      {failure.requestId && (
        <span>{t('common.requestId', { id: failure.requestId })}</span>
      )}
    </div>
  );
}
